import { render } from "./RollBetsElement.vue?vue&type=template&id=be3504b2&scoped=true"
import script from "./RollBetsElement.vue?vue&type=script&lang=js"
export * from "./RollBetsElement.vue?vue&type=script&lang=js"

import "./RollBetsElement.vue?vue&type=style&index=0&id=be3504b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3504b2"]])

export default __exports__